import React from "react";
import ReactSnowstorm from "react-snowstorm";

const Snow = () => {
  return (
    <ReactSnowstorm
      snowColor="#fff"
      flakesMax={200}
      flakesMaxActive={100}
      vMaxX={3}
      vMaxY={3}
      excludeMobile={false}
    />
  );
};

export default Snow;
